import React from "react";

import { Title } from "./AtTitle";

export default function AtTitle({ children, ...rest }) {
  return <Title {...rest}>{children}</Title>;
}
